// extracted by mini-css-extract-plugin
export default {"no-engagement-icon":"SocialEngagementTab_no-engagement-icon__pGxKd","add-icon":"SocialEngagementTab_add-icon__k3eSf","captiv8Icon":"SocialEngagementTab_captiv8Icon__ySAVD"};